import React, { useCallback, useState } from "react";
import { useHistory, useRouteMatch } from "react-router";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { useQuery } from "@apollo/client";
import { Graphql } from "../../../../graphql/_graphql";
import moment from "moment";
import { Toast } from "../../../../hooks/toast";
import { useTranslation } from "react-i18next";
import { PageLayout } from "src/components/shopify/PageLayout";
import {
  Badge,
  Box,
  Button,
  DatePicker,
  Icon,
  IndexTable,
  Layout,
  Modal as PolarisModal,
  TextField,
} from "@shopify/polaris";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import {
  LoadProductWithSKU,
  ProductSelectedProp,
} from "src/components/shopify/products/quick_product/LoadProductWithSKU";
import { Image } from "src/components/shopify/Image";
import { PolarisText } from "src/components/shopify/PolarisrText";
import { ArrowRightMinor } from "@shopify/polaris-icons";
import { Modal } from "src/hooks/modal";
import {
  ItemDiscountInput,
  useMerchantCreateDiscountItemMutation,
  useMerchantUpdateDiscountMutation,
} from "src/graphql/codegen_graphql";

export function DiscountFormScreen() {
  const seven_day = new Date();
  seven_day.setDate(seven_day.getDate() + 7);
  const { t } = useTranslation();
  const { params }: any = useRouteMatch();
  const { push } = useHistory();
  const [{ month, year }, setDate] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const [selectedDates, setSelectedDates] = useState({
    start: new Date(),
    end: seven_day,
  });
  const [selectProduct, setSelectProduct] = useState<ProductSelectedProp[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [open, setOpen] = useState(false);

  const { loading, data: dataQuery } = useQuery(Graphql.Query.QUERY_DISCOUNT_ITEM, {
    fetchPolicy: "no-cache",
    skip: params.id === undefined,
    variables: {
      campaign_id: Number(params.id),
    },
    onCompleted: (res) => {
      setSelectProduct(
        res.merchantDiscountItem.items.map((x: any) => {
          return {
            id: x.item.id,
            sku: [],
            all: true,
          };
        }),
      );
      setProducts(
        res.merchantDiscountItem.items.map((x: any) => {
          return {
            ...x,
            discount: x.discount,
            product: {
              ...x.item,
              discount: x.original_discount,
            },
          };
        }),
      );
      setSelectedDates({
        start: new Date(res.merchantDiscountItem.campaign.start_date),
        end: new Date(res.merchantDiscountItem.campaign.end_date),
      });
    },
  });

  const [merchantCreateDiscountItem] = useMerchantCreateDiscountItemMutation({
    refetchQueries: ["merchantDiscountItem", "merchantDiscountItemCampaign"],
    onCompleted: (data) => {
      if (data.merchantCreateDiscountItem === true) {
        push("/discount/list");
      }
    },
  });

  const [merchantUpdateDiscount] = useMerchantUpdateDiscountMutation({
    refetchQueries: ["merchantDiscountItem", "merchantDiscountItemCampaign"],
    onCompleted: (data) => {
      if (data.merchantUpdateDiscount === true) {
        push("/discount/list");
      }
    },
  });

  const handleSave = () => {
    if (products.length === 0) {
      Toast.onShow("Please add item for discount", "danger", "right");
      return;
    }

    const delete_data =
      params.id !== undefined
        ? dataQuery.merchantDiscountItem.items.filter((x: any) => !products.map((p) => p.id).includes(x.id))
        : [];

    Modal.dialog({
      title: t("confirmation"),
      flush: true,
      body: (
        <div>
          <div className="p-3">
            <span style={{ display: "flex", alignItems: "center" }}>
              Schedule:{" "}
              <span className="ml-2" style={{ display: "flex", alignItems: "center" }}>
                {moment(selectedDates.start).format("YYYY:MM:DD")} <Icon source={ArrowRightMinor as any} />
                {moment(selectedDates.end).format("YYYY:MM:DD")}
                <span className="ml-2">
                  ({moment(selectedDates.end).diff(moment(selectedDates.start), "days")}days)
                </span>
              </span>
            </span>
          </div>
          <div>
            <IndexTable
              headings={[{ title: "Code" }, { title: "Current" }, { title: "" }, { title: "Discount" }]}
              itemCount={products.length}
              selectable={false}
            >
              {products.map((x, i) => {
                return (
                  <IndexTable.Row key={i} id={i + ""} position={i}>
                    <IndexTable.Cell>
                      <strong>{x.product.code}</strong>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <strong>{x.product.discount}%</strong>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <Icon source={ArrowRightMinor as any} />
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <strong className="text-success">{x.discount}%</strong>
                    </IndexTable.Cell>
                  </IndexTable.Row>
                );
              })}
              {delete_data.map((x: any, i: number) => {
                return (
                  <IndexTable.Row key={i} id={i + ""} position={i} tone="critical">
                    <IndexTable.Cell>
                      <Badge tone="critical-strong" size="small">
                        Remove
                      </Badge>
                      <strong className="text-danger ml-2">{x.item.code}</strong>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <strong className="text-danger">{x.original_discount}%</strong>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <Icon source={ArrowRightMinor as any} tone="critical" />
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <strong className="text-success">{x.discount}%</strong>
                    </IndexTable.Cell>
                  </IndexTable.Row>
                );
              })}
            </IndexTable>
          </div>
        </div>
      ),
      buttons: [
        {
          title: t("cancel"),
          class: "danger",
        },
        {
          title: t("confirm"),
          class: "primary",
          onPress: () => {
            if (params.id === undefined) {
              const data: {
                start_date: string;
                end_date: string;
                data: ItemDiscountInput[];
              } = {
                start_date: moment(selectedDates.start).format("YYYY-MM-DD"),
                end_date: moment(selectedDates.end).format("YYYY-MM-DD"),
                data: products.map((x) => {
                  return {
                    item_id: Number(x.product.id),
                    original_discount: String(x.product.discount),
                    discount: String(x.discount),
                    campaign_id: 0,
                  };
                }),
              };
              merchantCreateDiscountItem({ variables: data });
            } else {
              const delete_data = dataQuery.merchantDiscountItem.items.filter(
                (x: any) => !products.map((p) => p.id).includes(x.id),
              );
              const data: {
                start_date: string;
                end_date: string;
                campaign_id: number;
                data: ItemDiscountInput[];
                delete_id: number[];
              } = {
                start_date: moment(selectedDates.start).format("YYYY-MM-DD"),
                end_date: moment(selectedDates.end).format("YYYY-MM-DD"),
                data: products.map((x) => {
                  return {
                    id: x.id,
                    item_id: Number(x.product.id),
                    original_discount: String(x.product.discount),
                    discount: String(x.discount),
                  };
                }),
                campaign_id: Number((params as any).id),
                delete_id: delete_data.map((x: any) => Number(x.id)),
              };
              merchantUpdateDiscount({ variables: data });
            }
          },
        },
      ],
    });
  };

  const handleDiscountInput = useCallback(
    (value, sku_index: number, index: number) => {
      let discount = value;
      if (value === "") {
        discount = "1";
      }
      const items = [...products];
      items[index].discount = discount;
      setProducts(items);
    },
    [products],
  );

  const handleMonthChange = useCallback((month: number, year: number) => setDate({ month, year }), []);

  return (
    <PageLayout
      pageProp={{
        title: params.id === undefined ? t("create_discount") : t("edit_discount"),
        primaryAction: { content: t("save"), onAction: handleSave },
      }}
      loading={loading}
    >
      <Layout>
        <Layout.Section>
          <PolarisCard padding={"0"} roundedAbove="sm">
            <Box padding={"300"} borderColor="border" borderBlockEndWidth="025">
              <div style={{ display: "flex" }}>
                <LoadProductWithSKU
                  productOnly
                  initialProductSelected={selectProduct}
                  onLoadProductInfo={(v) => {
                    setProducts(
                      v.map((x) => {
                        const findDiscount = products.find((f) => f.product.id === x.product.id);
                        return { ...x, ...findDiscount, discount: findDiscount ? findDiscount.discount : 1 };
                      }),
                    );
                  }}
                  onProductSelectedChange={setSelectProduct}
                />
                <PolarisModal
                  activator={
                    <div className="ml-3">
                      <Button size="slim" onClick={() => setOpen(!open)}>
                        {
                          (
                            <span style={{ display: "flex", alignItems: "center" }}>
                              {t("schedule")}:{" "}
                              <span className="ml-2" style={{ display: "flex", alignItems: "center" }}>
                                {moment(selectedDates.start).format("YYYY:MM:DD")}{" "}
                                <Icon source={ArrowRightMinor as any} />
                                {moment(selectedDates.end).format("YYYY:MM:DD")}
                                <span className="ml-2">
                                  ({moment(selectedDates.end).diff(moment(selectedDates.start), "days")}
                                  {t("days")})
                                </span>
                              </span>
                            </span>
                          ) as any
                        }
                      </Button>
                    </div>
                  }
                  open={open}
                  onClose={() => setOpen(false)}
                  title="Schedule Discount Campaign"
                  size="large"
                >
                  <PolarisModal.Section>
                    <DatePicker
                      month={month}
                      year={year}
                      onChange={setSelectedDates}
                      onMonthChange={handleMonthChange}
                      selected={selectedDates}
                      multiMonth
                      allowRange
                    />
                  </PolarisModal.Section>
                </PolarisModal>
              </div>
            </Box>
            <Box>
              <IndexTable
                headings={[
                  { title: t("product") },
                  { title: `${t("original_discount")} (%)` },
                  { title: `${t("new_discount")} (%)` },
                ]}
                itemCount={1}
                selectable={false}
                loading={loading}
              >
                {products.map((x, i) => {
                  const title = Object.values(x.product.title).filter((f) => !!f && f !== "MultiLangString")[0];
                  return (
                    <IndexTable.Row key={i} id={i + ""} position={i}>
                      <IndexTable.Cell>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Image alt="" source={x.product.picture} size="small" />
                          <div style={{ width: 150 }} className="ml-3">
                            <PolarisText as="p" variant="bodySm" truncate>
                              {title}
                            </PolarisText>
                            <small>L192: {x.product.code}</small>
                          </div>
                        </div>
                      </IndexTable.Cell>
                      <IndexTable.Cell>{Number(x.product.discount).toFixed(2)}%</IndexTable.Cell>
                      <IndexTable.Cell>
                        <div style={{ width: 150, position: "relative" }}>
                          <TextField
                            suffix="%"
                            autoComplete="off"
                            label
                            labelHidden
                            value={x.discount}
                            onChange={(v) => handleDiscountInput(v, 0, i)}
                            type="number"
                          />
                        </div>
                      </IndexTable.Cell>
                    </IndexTable.Row>
                  );
                })}
              </IndexTable>
            </Box>
          </PolarisCard>
        </Layout.Section>
      </Layout>
    </PageLayout>
  );
}
